/**
 * The clip-length presets the carousel offers.
 *
 * Declared once here and filtered against the range the backend serves from
 * `GET /api/v1/public/clip-lengths`, so the carousel can never offer a length
 * `ClipContentConfig` would refuse.
 */

export type ClipDurationLimits = {
  min_seconds: number
  max_seconds: number
  default_seconds: number
}

export type ClipLength = {
  value: string
  label: string
  min: number
  max: number
}

export const CLIP_LENGTHS: readonly ClipLength[] = [
  { value: 'auto', label: 'Auto', min: 15, max: 180 },
  { value: 'short', label: '< 30s', min: 5, max: 30 },
  { value: 'medium', label: '30s - 60s', min: 30, max: 60 },
  { value: 'long', label: '60s - 90s', min: 60, max: 90 },
  { value: 'extended', label: '90s - 3m', min: 90, max: 180 },
]

/** The presets the backend accepts; the whole list until the limits have loaded. */
export function clipLengthsWithin(limits: ClipDurationLimits | null): ClipLength[] {
  if (!limits) return [...CLIP_LENGTHS]
  return CLIP_LENGTHS.filter(
    (length) => length.min >= limits.min_seconds && length.max <= limits.max_seconds,
  )
}
